import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import intraoralSegmentronPreview from '@/shared/assets/images/intraoralSegmentronPreview.png';
import segmentronPreview from '@/shared/assets/images/segmentronPreview.png';

export const getSegmentronPreview = (reportType: ReportType): string => {
  if (reportType === ReportType.ReportType_IOS_Segmentation) {
    return intraoralSegmentronPreview;
  }

  return segmentronPreview;
};
